import { ContactListDataMapper } from './ContactListMapper.types'

class ContactListMapper {
  toPersistence(domainData: ContactListDataMapper) {
    return {
      email: domainData?.email,
      celular: domainData?.celular,
    }
  }
}

export default new ContactListMapper()
